import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SandboxService {
  private apiRoute = environment.apiUrl;

  constructor(private http: HttpClient) {}

  public testGet(): Observable<Object> {
    return this.http.get(`${this.apiRoute}/note/add`);
  }
}
